"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../constants");
var _colors = require("../../birch/colors");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var azaleaVersion = {
  empty: {
    borderColor: _constants.colors.mediumGrey,
    backgroundColor: _constants.colors.white
  },
  enabled: {
    borderColor: '#2c91fc',
    backgroundColor: '#3b99fc',
    iconColor: _constants.colors.white
  },
  disabled: {
    borderColor: '#c8c8c8',
    backgroundColor: _constants.colors.lightGrey,
    iconColor: _constants.colors.white
  },
  borderRadius: '4px',
  dropShadow: 'drop-shadow(0 1px 1px #999999)',
  labelColor: 'inherit'
};
var birchVersion = {
  empty: {
    borderColor: _colors.FullPalette.GREEN_700,
    backgroundColor: _colors.FullPalette.WHITE
  },
  enabled: {
    borderColor: _colors.FullPalette.GREEN_700,
    backgroundColor: _colors.FullPalette.WHITE,
    iconColor: _colors.FullPalette.GREEN_700
  },
  disabled: {
    borderColor: _colors.FullPalette.GREY_700,
    backgroundColor: _colors.FullPalette.WHITE,
    iconColor: _colors.FullPalette.GREY_700
  },
  borderRadius: '5px',
  dropShadow: 'none',
  labelColor: _colors.FullPalette.EVERGREEN_700
};
var versionSelector = (0, _constants.buildVersionSelector)(azaleaVersion, birchVersion);
var TristateCheckboxWithLabel = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TristateCheckboxWithLabel, _React$Component);
  var _super = _createSuper(TristateCheckboxWithLabel);
  function TristateCheckboxWithLabel() {
    var _this;
    (0, _classCallCheck2["default"])(this, TristateCheckboxWithLabel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.handleClick = function (ev) {
      if (_this.props.disabled) {
        return false;
      }
      return _this.props.onChange(ev);
    };
    _this.getAriaChecked = function () {
      var checkedState = _this.props.checkedState;
      switch (checkedState) {
        case 'empty':
          return 'false';
        case 'indeterminate':
          return 'mixed';
        case 'checked':
          return 'true';
      }
    };
    _this.getBoxComponent = function () {
      var _this$props = _this.props,
        checkedState = _this$props.checkedState,
        disabled = _this$props.disabled;
      if (disabled) {
        return BoxDisabled;
      } else {
        if (checkedState === 'empty') {
          return BoxEnabledEmpty;
        } else {
          return BoxEnabledChecked;
        }
      }
    };
    _this.getIcon = function () {
      var _this$props$theme, _this$props3, _this$props3$theme;
      var _this$props2 = _this.props,
        checkedState = _this$props2.checkedState,
        disabled = _this$props2.disabled;
      var checkColor = disabled ? versionSelector((_this$props$theme = _this.props.theme) === null || _this$props$theme === void 0 ? void 0 : _this$props$theme.name).disabled.iconColor : versionSelector((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : (_this$props3$theme = _this$props3.theme) === null || _this$props3$theme === void 0 ? void 0 : _this$props3$theme.name).enabled.iconColor;
      switch (checkedState) {
        case 'empty':
          return null;
        case 'indeterminate':
          return /*#__PURE__*/React.createElement(IconDash, null);
        case 'checked':
          return /*#__PURE__*/React.createElement(IconCheckmark, {
            xmlns: "http://www.w3.org/2000/svg",
            width: "12px",
            height: "12px",
            viewBox: "-1 -1 11 11"
          }, /*#__PURE__*/React.createElement("path", {
            fill: checkColor,
            stroke: checkColor,
            strokeWidth: "0.45",
            d: "M7.74102446,0.205040582 C8.04525578,-0.0843809683 8.51975872,-0.0650721456 8.80085644,0.248168045 C9.08195415,0.561408235 9.06320065,1.04996211 8.75896933,1.33938366 L3.47305862,7.79495982 C3.16967672,8.0835733 2.69675054,8.06529178 2.41524145,7.75406866 L0.20115767,5.24932692 C-0.0811395998,4.93723242 -0.064260592,4.44860609 0.238857989,4.15794947 C0.54197657,3.86729284 1.01654988,3.88467167 1.29884715,4.19676616 L3.00380162,6.13863863 L7.74102446,0.205040582 Z"
          }));
        default:
          return null;
      }
    };
    return _this;
  }
  (0, _createClass2["default"])(TristateCheckboxWithLabel, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        checkedState = _this$props4.checkedState,
        disabled = _this$props4.disabled,
        label = _this$props4.label,
        name = _this$props4.name;
      var BoxComponent = this.getBoxComponent();
      return /*#__PURE__*/React.createElement(Container, {
        disabled: disabled,
        onClick: this.handleClick
      }, /*#__PURE__*/React.createElement(BoxComponent, {
        "data-provides": "tristate-checkbox-icon",
        className: "checkbox-icon",
        "aria-checked": this.getAriaChecked(),
        "aria-labelledby": "".concat(name, "-label"),
        checked: checkedState === 'checked',
        disabled: disabled,
        role: "checkbox"
      }, this.getIcon()), /*#__PURE__*/React.createElement(Label, {
        "data-provides": "tristate-checkbox-label"
        // @ts-expect-error - TS2769 - No overload matches this call.
        ,
        disabled: disabled,
        id: "".concat(name, "-label")
      }, label));
    }
  }]);
  return TristateCheckboxWithLabel;
}(React.Component);
TristateCheckboxWithLabel.defaultProps = {
  checkedState: 'empty',
  disabled: false,
  label: '',
  labelFontWeight: 'normal'
};
var IconCheckmark = _styledComponents["default"].svg.withConfig({
  displayName: "tristate_checkbox_with_label__IconCheckmark"
})([""]);
var IconDash = _styledComponents["default"].div.withConfig({
  displayName: "tristate_checkbox_with_label__IconDash"
})(["background:", ";border-radius:1px;height:2px;width:10px;"], function (props) {
  var _props$theme;
  return versionSelector((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.name).iconColor;
});
var Box = _styledComponents["default"].div.withConfig({
  displayName: "tristate_checkbox_with_label__Box"
})(["align-items:center;border-radius:", ";display:flex;height:16px;justify-content:center;margin:0;min-height:16px;min-width:16px;padding:0;width:16px;"], function (props) {
  var _props$theme2;
  return versionSelector((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.name).borderRadius;
});
var BoxEnabledEmpty = (0, _styledComponents["default"])(Box).withConfig({
  displayName: "tristate_checkbox_with_label__BoxEnabledEmpty"
})(["border:1px solid ", ";background:", ";"], function (props) {
  var _props$theme3;
  return versionSelector((_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.name).empty.borderColor;
}, function (props) {
  var _props$theme4;
  return versionSelector((_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.name).empty.backgroundColor;
});
var BoxEnabledChecked = (0, _styledComponents["default"])(Box).withConfig({
  displayName: "tristate_checkbox_with_label__BoxEnabledChecked"
})(["border:1px solid ", ";background:", ";"], function (props) {
  var _props$theme5;
  return versionSelector((_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : _props$theme5.name).enabled.borderColor;
}, function (props) {
  var _props$theme6;
  return versionSelector((_props$theme6 = props.theme) === null || _props$theme6 === void 0 ? void 0 : _props$theme6.name).enabled.backgroundColor;
});
var BoxDisabled = (0, _styledComponents["default"])(Box).withConfig({
  displayName: "tristate_checkbox_with_label__BoxDisabled"
})(["border:1px solid ", ";background:", ";"], function (props) {
  var _props$theme7;
  return versionSelector((_props$theme7 = props.theme) === null || _props$theme7 === void 0 ? void 0 : _props$theme7.name).disabled.borderColor;
}, function (props) {
  var _props$theme8;
  return versionSelector((_props$theme8 = props.theme) === null || _props$theme8 === void 0 ? void 0 : _props$theme8.name).disabled.backgroundColor;
});
var Container = _styledComponents["default"].div.withConfig({
  displayName: "tristate_checkbox_with_label__Container"
})(["", " cursor:", ";display:inline-flex;width:100%;.checkbox-icon{margin-top:3px;}& > div", "{margin-bottom:0;margin-right:10px;}"], /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return !!props.disabled ? 'default' : 'pointer';
}, Box);
Container.defaultProps = {
  disabled: false
};
var Label = _styledComponents["default"].span.withConfig({
  displayName: "tristate_checkbox_with_label__Label"
})(["", " cursor:", ";font-size:14px;margin-top:2px;", " ", ";color:", ";"], /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return !!props.disabled ? 'default' : 'pointer';
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return (0, _constants.fontWeight)(props.fontWeight);
}, function (props) {
  var _props$theme9;
  return versionSelector((_props$theme9 = props.theme) === null || _props$theme9 === void 0 ? void 0 : _props$theme9.name).labelColor;
});
var ThemedTristateCheckboxWithLabel = (0, _styledComponents.withTheme)(TristateCheckboxWithLabel);
var _default = ThemedTristateCheckboxWithLabel;
exports["default"] = _default;